import axios from "@axios";
import store from "@/store";
import {EventBus} from "@/libs/event-bus";

export default {
  namespaced: true,
  state: {
    takenAlarms: [],
    inReviewAlarms: [],
    userTakenAlarms: [],
  },
  getters: {
    getTakenAlarms(state) {
      return state.takenAlarms;
    },
  },
  mutations: {
    setTakenAlarms(state, value) {
      state.takenAlarms = value;
    },
  },
  actions: {
    async getTakenAlarms({commit}, params) {
      try {
        const response = await axios.get("v1/alarms/workflow/alarms-in-progress", {params});

        let data = response.data.data;

        commit("setTakenAlarms", data);

        return data;
      } catch (e) {
        console.error('getTakenAlarms:', e.message);
        return [];
      }
    },
    async takeAlarm({dispatch}, params) {
      try {
        const {data} = await axios.post("v1/alarms/workflow/execute-action", params);

        EventBus.emit("update-alarms", {id: params.id_alarm});
        await dispatch("getTakenAlarms");

        return data;
      } catch (e) {
        console.error('takeAlarm:', e.message);
        return {
          success: false,
          message: e.response?.data?.message ?? e.message,
        };
      }
    },
    clear({commit}) {
      commit("setTakenAlarms", []);
      commit("setUserTakenAlarms", []);
    },
  },
};
